import { render, staticRenderFns } from "./pubrule.vue?vue&type=template&id=6290c850&"
import script from "./pubrule.vue?vue&type=script&lang=js&"
export * from "./pubrule.vue?vue&type=script&lang=js&"
import style0 from "./pubrule.vue?vue&type=style&index=0&id=6290c850&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports